import AccordionDetails from '@mui/material/AccordionDetails';
import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import {
  detailsBtns,
  docInfoBox,
  docInfoText,
  lineBorder,
  detailsBox,
  detailsWraper,
  accordionDetail,
  balanceWithBtnsBox,
} from './AccountDetails.sx';
import DashboardWarningIcon from 'app/components/Icons/DashboardWarningIcon';
import { green3, grey12, red2 } from 'app/components/ThemeProvider/colors';
import ExtractModal from 'app/components/ExtractModal';
import { AccountValue } from 'app/constants/types';
import RequisiteModal from 'app/components/RequisiteModal';
import IncomingPlus from 'app/components/Icons/IncomingPlus';
import useCurrencySymbol from 'app/utils/customHooks/useCurrencySymbol';
import { useLocation, useNavigate } from 'react-router-dom';
interface DetailsProps {
  accountOptions: any;
  accountValue: any;
  accountOnChange: (newValue: any) => void;
  accountsList: any;
}

const AccountDetails = (props: DetailsProps) => {
  const { accountValue, accountOptions,accountsList } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const lang = location.pathname.substring(0, 3);

  const navigateToTransfer = () => {
    navigate(`${lang}/transfer-page`, { state: { selectedValue: accountValue } });
  };

  return (
    <AccordionDetails sx={accordionDetail}>
      <Box sx={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
        <Typography sx={{ fontSize: '17px', fontWeight: 400, color: grey12 }}>Balans</Typography>
        <Box sx={balanceWithBtnsBox}>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '24px' }}>
            <Typography sx={{ fontSize: '44px', fontWeight: 600 }}>
              {accountValue.balance} {useCurrencySymbol(accountValue.currency)}
            </Typography>
            {accountValue?.taxOrder === 'YES' && (
              <Box sx={docInfoBox}>
                <DashboardWarningIcon />
                <Typography sx={docInfoText}>Sərəncam</Typography>
              </Box>
            )}
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: '12px', flexWrap: 'wrap' }}>
            <Button sx={detailsBtns} onClick={navigateToTransfer}>
              <IncomingPlus />
              Mədaxil
            </Button>
            <RequisiteModal accountValue={accountValue.iban} accountCurrency={accountValue.currency} />
            <ExtractModal accountsList={accountsList}  accountValue={accountValue.iban}></ExtractModal>
          </Box>
        </Box>
      </Box>
      <Box sx={lineBorder}></Box>
      <Box sx={detailsWraper}>
        {/*<Box sx={detailsBox}>*/}
        {/*  <Typography sx={{ fontSize: '17px', fontWeight: 400, color: grey12 }}>İstifadə oluna bilən məbləğ</Typography>*/}
        {/*  <Typography sx={{ fontSize: '22px', fontWeight: 600, color: green3 }}>*/}
        {/*    {+accountValue.balance - +accountValue.blocked <= 0 ? '0' : +accountValue.balance - +accountValue.blocked} ₼*/}
        {/*  </Typography>*/}
        {/*</Box>*/}
        <Box sx={detailsBox}>
          <Typography sx={{ fontSize: '17px', fontWeight: 400, color: grey12 }}>Bloklaşdırılmış məbləğ</Typography>
          <Typography sx={{ fontSize: '22px', fontWeight: 600, color: red2 }}>{accountValue.blocked} ₼</Typography>
        </Box>
        {accountValue.govAmount > 0 && (
          <Box sx={detailsBox}>
            <Typography sx={{ fontSize: '17px', fontWeight: 400, color: grey12 }}>Dövlət vəsaiti</Typography>
            <Typography sx={{ fontSize: '22px', fontWeight: 600, color: '#FF9E1F' }}>
              {accountValue.govAmount} ₼
            </Typography>
          </Box>
        )}
      </Box>
    </AccordionDetails>
  );
};

export default AccountDetails;
